import {HTMLAttributes} from "react"
import {styled} from "@mui/material/styles"
import {useTranslation} from "react-i18next"

import {Frequency, FREQUENCIES} from "./Frequency"

export function FrequencyToggleGroup({
	frequency,
	handleFrequencyChange,
}: {
	frequency: Frequency
	handleFrequencyChange: (newFreq: Frequency) => void
}) {
	const {t} = useTranslation()

	return (
		<ButtonsDiv>
			{FREQUENCIES.map((option) => (
				<StyledButton
					key={option}
					onClick={() => handleFrequencyChange(option)}
					selected={frequency === option}
				>
					{t(`payment_arrangement_setup_page.frequency.${option}.label`)}
				</StyledButton>
			))}
		</ButtonsDiv>
	)
}

const ButtonsDiv = styled("div")`
	display: flex;
	height: 3rem;
	align-items: stretch;
	flex-shrink: 0;
	align-self: stretch;
	background: #f6f6f6;
	border-radius: 0.5rem;
	padding: 2px;
`

const StyledButton = styled(({selected, ...props}: {selected: boolean} & HTMLAttributes<HTMLButtonElement>) => (
	<button {...props} />
))`
	flex: 1 1 0px;
	border-radius: 0.5rem;
	border: 0px;
	background-color: ${({selected}) => (selected ? "#474cde" : "#f6f6f6")};
	color: ${({selected}) => (selected ? "#fff" : "#000244")};
	font-weight: ${({selected}) => (selected ? "500" : "400")};
	font-size: 0.8125rem;
`
